import React from 'react';
import { Box} from '@mui/material';
import PropTypes from 'prop-types';
import './styles.css';
import FooterPage from './FooterPage'; 

const VerificationCode = ({ onSuccess, passcode }) => {
  return (
    <Box className="verification-box">
    <div className= "container">
      <div className="verification-code">{passcode}</div>
    </div>
    <FooterPage />
    </Box>
  );
};

VerificationCode.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default VerificationCode;

